export const defaultConfig = {
  screen: false,
  text: '加载中',
  textColor: '#515a6e',
  iconColor: '#2d8cf0',
  background: '#fff',
};

export default {};
